/**
 * Memory Overview Tab
 *
 * Shows memory usage statistics, recent activity, and notifications.
 */
import { Card } from '@personic/shared'
import { useMemoryStats } from '../../../hooks/useMemory'

export function MemoryOverview() {
  const { data: stats, isLoading } = useMemoryStats()

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[1, 2, 3].map(i => (
          <Card key={i} className="p-6 bg-neutral-900/50 border-neutral-800 animate-pulse">
            <div className="h-16" />
          </Card>
        ))}
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className="p-6 bg-neutral-900/50 border-neutral-800">
          <p className="text-sm text-neutral-400">Episodes</p>
          <p className="text-3xl font-bold text-white mt-1">
            {stats?.episode_count ?? 0}
          </p>
          <p className="text-xs text-neutral-500 mt-1">
            {stats?.oldest_episode ? `Since ${new Date(stats.oldest_episode).toLocaleDateString()}` : 'No episodes yet'}
          </p>
        </Card>

        <Card className="p-6 bg-neutral-900/50 border-neutral-800">
          <p className="text-sm text-neutral-400">Semantic Nodes</p>
          <p className="text-3xl font-bold text-white mt-1">
            {stats?.semantic_node_count ?? 0}
          </p>
          <p className="text-xs text-neutral-500 mt-1">
            {stats?.semantic_size_bytes ? `${(stats.semantic_size_bytes / 1024).toFixed(1)} KB` : '0 KB'}
          </p>
        </Card>

        <Card className="p-6 bg-neutral-900/50 border-neutral-800">
          <p className="text-sm text-neutral-400">Procedural Patterns</p>
          <p className="text-3xl font-bold text-white mt-1">
            {stats?.procedural_pattern_count ?? 0}
          </p>
          <p className="text-xs text-neutral-500 mt-1">
            Behavioral patterns detected
          </p>
        </Card>
      </div>

      <Card className="p-6 bg-neutral-900/50 border-neutral-800">
        <h3 className="text-lg font-semibold text-white mb-4">Memory Status</h3>
        <div className="text-sm text-neutral-400">
          <p>Memory module is active. Episodic records are being consolidated into semantic knowledge.</p>
          {stats?.newest_episode && (
            <p className="mt-2">
              Last activity: {new Date(stats.newest_episode).toLocaleString()}
            </p>
          )}
        </div>
      </Card>
    </div>
  )
}
